module.exports = __webpack_public_path__ + "static/media/notQualified.8c0f24a0.png";